












import Vue from 'vue';
import BaseEditorText from '../base/BaseEditorText.vue';

export default Vue.extend({
  name: 'BlockEditorHeading1',
  components: {
    BaseEditorText,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      styling: { fontSize: '2rem', fontWeight: '600' },
    };
  },
});
